import React, { Component } from 'react';
import { ListGroup, Button, Form } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Question extends Component {
  state = { selectedAnswerId: null };

  handleOptionChange = (event) => {
    this.setState({
      selectedAnswerId: parseInt(event.target.value, 10)
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    // onAnswerSubmit jest przekazywana z komponentu Exam
    if (this.state.selectedAnswerId) {
      this.props.onAnswerSubmit(this.state.selectedAnswerId, this.props.questionId);
    }
  };

  render() {
    const { question, answers, imageUrl, t } = this.props;

    return (
      <div className="lt-question-card lt-fade-in">
        <Form onSubmit={this.handleSubmit}>
          {imageUrl && (
            <div className="mb-3 text-center">
              <img
                src={imageUrl}
                alt=""
                style={{ maxWidth: '100%', maxHeight: '55vh', width: 'auto', height: 'auto', borderRadius: '8px', objectFit: 'contain' }}
              />
            </div>
          )}
          <div className="lt-question-title" style={{background:'rgba(255,255,255,0.97)',borderRadius:'8px',padding:'13px 16px',marginBottom:'16px',boxShadow:'0 1px 5px rgba(0,0,0,0.08)'}}>
            <h3>{question}</h3>
          </div>
          <ListGroup className="mb-3">
            {answers.map(answer => (
              <ListGroup.Item key={answer.id} as="label" className="d-flex justify-content-between align-items-center">
                <Form.Check
                  type="radio"
                  name="answers"
                  value={answer.id}
                  id={`answer-${answer.id}`}
                  checked={this.state.selectedAnswerId === answer.id}
                  onChange={this.handleOptionChange}
                  label={answer.answer}
                  className="mb-2"
                />
              </ListGroup.Item>
            ))}
          </ListGroup>
          <div className="d-grid">
            <Button variant="success" type="submit" className="mt-3">{t('submit_next_question')}</Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default withTranslation()(Question);
